import React from 'react';
import PropTypes from 'prop-types';
import { FiInfo } from 'react-icons/fi';

import arrowDown from '../assets/images/arrow-down.svg';
class Input extends React.Component {
  state = {
    newValue: '',
  };

  componentDidMount() {
    const { value } = this.props;
    this.onChange(value);
  }

  onChange = newValue => {
    const { onChange } = this.props;
    this.setState({
      newValue,
    }, () => {
      onChange({ target: { value: newValue } });
    });
  }

  render() {
    const {
      onChange, inputType, type, value, placeholder, options, disabled, autoComplete,
      name, id, children, required, invalidMessage, onBlur, onFocus, noPlaceholder, boldLabel, noUnderline,
    } = this.props;
    const { newValue } = this.state;
    switch (inputType) {
    case 'select':
      return (
        <div id="input-div">
          {noPlaceholder ? '' : <div className={`label ${boldLabel && 'bold'}`}>{placeholder}</div>}
          <div className="select-dropdown-div">
            <select
              value={value}
              onChange={(e) => this.onChange(e.target.value)}
              placeholder={placeholder}
              options={options}
              disabled={disabled}
              autoComplete="off"
              autoFocus={false}
              required={required}
              name={name}
              className={`native-select ${noUnderline ? '' : 'select-underline'}`}
            >
              {noPlaceholder && <option value="">{placeholder}</option>}
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <img className="select-dropdown-icon" src={arrowDown} alt="Arrow Down" />
          </div>
          <div className="invalid-message">
            {(invalidMessage) && (
              <>
                <FiInfo className="input-error-icon icon-error" />
                <span className="input-error-text">
                  {invalidMessage}
                </span>
              </>
            )}
          </div>
        </div>
      );
    case 'radio':
      return (
        <div className="radio-group">
          {options.map(option => (
            <div key={option.value} className="radio-item" onClick={() => this.onChange(option.value)}>
              <span className={`radio-button${newValue === option.value && value === option.value ? ' active' : ''}`}>
                <div />
              </span>
              {option.label}
            </div>
          ))}
        </div>
      );

    case 'custom-select':
      return (
        <div id="input-div">
          <div className={`label ${boldLabel && 'bold'}`}>{placeholder}</div>
          <img className="select-dropdown-icon" src={arrowDown} alt="Arrow Down" />
          <select
            name={name}
            id={id}
            onChange={onChange}
            className="select"
            type="text"
          >
            {children}
          </select>
        </div>
      );

    default:
      return (
        <div id="input-div">
          <div className={`label ${boldLabel && 'bold'}`}>{placeholder}</div>
          <input
            disabled={disabled}
            className="input"
            onChange={onChange}
            type={type}
            value={value}
            onFocus={onFocus}
            onBlur={onBlur}
            autoComplete={autoComplete}
            required={required}
            name={name}
          />
          <div className="invalid-message">
            {(invalidMessage) && (
              <>
                <FiInfo className="input-error-icon icon-error" />
                <span className="input-error-text">
                  {invalidMessage}
                </span>
              </>
            )}
          </div>
        </div>
      );
    }
  }
}

Input.propTypes = {
  inputType: PropTypes.string,
  noPlaceholder: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.string,
    }).isRequired
  ),
  placeholder: PropTypes.node,
  value: PropTypes.node.isRequired,
};

export default Input;
